import React from 'react';
import PropTypes from 'prop-types';
import ProductReviewListItem from './ProductReviewListItem';

function ProductReviewList({ reviews,
    handleReviewClick }) {
    const reviewsList = reviews.map(review => <ProductReviewListItem key={`review-${review.id}`}
        review={review}
        handleReviewClick={handleReviewClick} />);
    return (<ul className="product__reviews__list">{reviewsList}</ul>)
};

ProductReviewList.propTypes = {
    reviews: PropTypes.array.isRequired,
    handleReviewClick: PropTypes.func
}

export default ProductReviewList;